module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-woman-20@2x_bc51b6839f85bef5ed1cef74d78f3928.jpg";